<template>
  <div class="rank">
    <h4 class="title">{{ title }}</h4>
    <ul class="list">
      <div class="block" v-if="!list || list.length == 0">暂无数据</div>
      <li :key="index" v-for="(item, index) in list">
        <span :class="index < 3 ? 'active' : null">{{ index + 1 }}</span>
        <span class="name">
          {{ item.name }}
          <div class="avatar" v-if="item.avatar">
            <a-avatar size="small" icon="user" :src="item.avatar"/>
          </div>
        </span>
        <span>{{ item.total }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RankList',
  // ['title', 'list']
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: null
    }
  }
}
</script>

<style lang="less" scoped>
.rank {
  padding: 0 32px 32px 72px;

  .list {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    .block {
      min-height: 100px;
      text-align: center;
      background: #f8f8f8;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    li {
      margin-top: 16px;

      span {
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        line-height: 22px;

        &:first-child {
          background-color: #f5f5f5;
          border-radius: 3px;
          display: inline-block;
          font-size: 12px;
          font-weight: 600;
          margin-right: 24px;
          height: 20px;
          line-height: 20px;
          width: 20px;
          text-align: center;
        }
        &.active {
          background-color: #314659;
          color: #fff;
        }
        &:last-child {
          float: right;
        }
      }
      .name {
        position: relative;
        .avatar {
          position: absolute;
          top: 0;
          left: -20px;
        }
      }
    }
  }
}
.mobile .rank {
  padding: 0 32px 32px 32px;
}
</style>
